import { render, staticRenderFns } from "./ServiceReset.vue?vue&type=template&id=7704fe6a"
import script from "./ServiceReset.vue?vue&type=script&lang=js"
export * from "./ServiceReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports